import { Fragment } from "react";
import { Link } from "react-router-dom";

export interface SummaryPart {
  /** "12 posts this week", "3 waiting for you" */
  text: string;
  /** Where the part leads, usually a page in another step of the same module, with `?channel=` when it helps. */
  to?: string;
}

/**
 * The one line at the top of an account page: a sentence of counts, each linking into the other steps, for example
 * "12 posts this week, 3 waiting for you, 4 leads." Parts with nothing to say are left out by the caller.
 */
export function AccountSummary({ parts, label = "Summary" }: { parts: SummaryPart[]; label?: string }) {
  if (!parts.length) return null;
  return (
    <p className="account-summary" aria-label={label}>
      {parts.map((p, i) => (
        <Fragment key={`${i}-${p.text}`}>
          {i > 0 && ", "}
          {p.to ? <Link to={p.to}>{p.text}</Link> : p.text}
        </Fragment>
      ))}
      .
    </p>
  );
}
